import { BaseSidebarObject } from '@y42/gojs';
import { IBackgroundColorNode, IShadowNode, ITextNode, IZOrderableNode } from '../../common/models/node.interfaces';

export class StickyNode
  extends BaseSidebarObject
  implements IShadowNode, IBackgroundColorNode, ITextNode, IZOrderableNode
{
  constructor(
    public key = '',
    public category = '',
    public size = '100 100',
    public location = '0 0',
    public background = '',
    public text = '',
    public textColor = '',
    public shadowColor = '',
    public shadowOffset = '',
    public shadowBlur = 0,
    public font = '',
    public group = '',
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
